import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { QuestionarioEmailCel } from "../interfaces/entities/QuestionarioEmailCel";
import { RegistrarBeneficiario } from "../interfaces/entities/RegistrarBeneficiario";
import { HttpResponse } from "../interfaces/services/HttpResponse";
import { Response } from "../interfaces/services/Response";

export const getBeneficiario = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/login/getbeneficiario', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getRegistroBeneficiario = async (dtNasc: string, cpf: string, numeroCartao?: string): Promise<Response | null> => {
  const response = await apiClientes.get(
    `/Login/GetRegistroBeneficiario?${numeroCartao ? ('numeroCartao=' + numeroCartao + '&') : ''}cpf=${cpf}&dtNasc=${dtNasc}`
  );
  return response;
};

export const validarCRM = async (username: string): Promise<string | null> => {
  try {
    const response = await apiClientes.post('/Login/ValidarCRM', {
      crm: username
    });
    return response.data;

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const tokenBenefExt = async (token: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Login/TokenBenefExt', {
      Token: token
    });
    return response;

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getContratosBeneficiario = async (username: string, password: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Login/GetContratosBeneficiario', {
      login: username,
      senha: btoa(password)
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const registrarBeneficiario = async (payload: RegistrarBeneficiario): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Login/RegistrarBeneficiario', payload);
    return response
  } catch (error: any) {
    const errorData = error?.response?.data;
    return errorData
  }
};

export const getQuestRecuperaLogin = async (idUsrContr: string/* , numeroCartao: string */): Promise<any | null> => {
  try {
    const response = await apiClientes.post(`/Login/GetQuestRecuperaLogin`, {
      /*       numeroCartao: numeroCartao, */
      idUsrContr: idUsrContr
    });
    return response;
  } catch (error: any) {
    const errorData = error?.response?.data;
    return errorData
  }
}

export const postValidarquestionarioemailcel = async (questionario: QuestionarioEmailCel): Promise<Response | null> => {
  try {
    const response = await apiClientes.post(`/Login/validarquestionarioemailcel`, questionario);
    return response;
  } catch (error: any) {
    const errorData = error?.response?.data;
    return errorData
  }
}

export const getTokenBenefClientes = async (username: string, password: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/login/tokenbenef', {
      login: username,
      senha: btoa(password),
      idEmpresa: "1"
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const postRefreshToken = async (accessToken: string, refreshToken: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/login/refresh', {
      accessToken: accessToken,
      refreshToken: refreshToken
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getUrlNavegacaoTeleorient = async (): Promise<string | null> => {
  try {
    const response = await apiClientes.get('/login/gettokennavegacaoteleorient', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const alterarSenha = async (senha: string, novaSenha: string, novaSenhaConfirmacao: string): Promise<HttpResponse<any> | null> => {
  try {
    const response = await apiClientes.post('/Login/AlterarSenha', {
      senha,
      novaSenha,
      novaSenhaConfirmacao
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const cancelarRegistroBeneficiario = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Login/CancelarRegistroBeneficiario', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};